<template>
  <!-- Main content -->
  <section class="content">
    <div class="container-fluid">
      <slot></slot>
    </div><!-- /.container-fluid -->
  </section>
  <!-- /.content -->
</template>

<script>
export default {
  name: "Content"
}
</script>

<style scoped>

</style>